<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="close">
          <div class="modal-container" @click.stop>
            <div class="modal-body">
              <slot name="body">
                <div class="m-auto">
                  <div class="modal-body text-center p-3">
                    <img
                      :src="icon.logo_icon"
                      alt="Namtang App Logo"
                      class="app-logo mb-3"
                    />

                    <h3 class="font-weight-bold mb-3">
                      {{ $t('message.app_promotional_modal.title') }}
                    </h3>

                    <p class="text--secondary mb-4">
                      {{ $t('message.app_promotional_modal.detail') }}
                    </p>

                    <div class="d-flex justify-content-center mb-4">
                      <img
                        :src="icon.ios_download_icon"
                        alt="Download on the App Store"
                        class="store-badge mr-2"
                        @click.prevent="openUrl('https://apps.apple.com/app/id1443449343')"
                      />
                      <img
                        :src="icon.android_download_icon"
                        alt="Get it on Google Play"
                        class="store-badge"
                        @click.prevent="openUrl('https://play.google.com/store/apps/details?id=th.go.otp.namtang')"
                      />
                    </div>

                    <a href="#" class="stay-link" @click.prevent="close">
                      {{ $t('message.app_promotional_modal.stay') }}
                    </a>
                  </div>
                </div>
              </slot>
            </div>
            <div class="btn-close cursor" @click="close" style="position: absolute; right: 8px; top: 12px;">
              <img height="28" :src="icon.close_icon" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppPromotionalModal',
  data () {
    return {
      is_desktop: this.$parent.isDesktop(),
      showModal: false,
      icon: {
        close_icon: require('@/assets/icon/ic_close_btn_black.png'),
        logo_icon: require('@/assets/logo.png'),
        android_download_icon: require('@/assets/android_download.png'),
        ios_download_icon: require('@/assets/ios_download.png'),
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.is_desktop) return
      const lastOpenTimeStamp = localStorage.getItem('lastOpenTimeStamp')
      // show again if it's not shown for 1 day (60 * 60 * 24 * 1)
      const threshold = (60 * 60 * 24 * 1)
      if (!lastOpenTimeStamp || (parseInt((new Date() - new Date(lastOpenTimeStamp)) / 1000) > threshold)) {
        this.showModal = true
        localStorage.setItem('lastOpenTimeStamp', new Date())
      }
    },
    close () {
      this.showModal = false
    },
    openUrl (url) {
      window.open(url, '_blank')
    },
  }
};
</script>

<style scoped lang="scss">
.modal-container {
  width: calc(100vw - 64px);
  max-width: 378px;
  position: relative;

  .modal-body {
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
  }
}

.app-logo {
  max-width: 80px;
  height: auto;
}

.store-badge {
  height: 45px;
  width: auto;
}
</style>
